import { render } from "./DataSourceStatus.vue?vue&type=template&id=520c58ae&ts=true"
import script from "./DataSourceStatus.vue?vue&type=script&lang=ts"
export * from "./DataSourceStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__